import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";
import { FormEditSLider } from "./FormEditSLider";

export const PanelEditSlider = () => {
    const [isCategoriesLoading, setCategoriesLoading] = useState(false); // Not used but kept for compatibility
    const [categories, setCategories] = useState([]); // Not used but kept for compatibility
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [sliderData, setSliderData] = useState(null);

    const fetchSliderData = async () => {
        try {
            setIsLoading(true);
            const { response } = await Helper.Get({
                url: `${api_Routes.Slider.View}/${id}`,
            });

            if (response && response.success) {
                // Convert active to string for RadioGroup compatibility
                const formattedData = {
                    ...response.data,
                    active: response.data.active.toString()
                };
                setSliderData(formattedData);
            }
        } catch (error) {
            console.error("Error fetching slider data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchSliderData();
    }, [id]);

    return (
        <div>
            <PanelHead
                title={
                    isLoading ? (
                        <div className="flex items-center gap-4">
                            Edit Slider <CircularProgress size={24} />
                        </div>
                    ) : (
                        <div className="flex items-center justify-between w-full gap-4">
                            <div>Edit Slider: {sliderData?.title}</div>
                        </div>
                    )
                }
            />
            <PanelBody
                content={
                    isLoading ? (
                        <LinearProgress />
                    ) : (
                        sliderData && (
                            <FormEditSLider
                                data={sliderData}
                                setData={setSliderData}
                                categories={categories}
                                isCategoriesLoading={isCategoriesLoading}
                            />
                        )
                    )
                }
            />
        </div>
    );
};